/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

const ipLoopBack = `${process.env.VUE_APP_URL}`

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

function recognizeImpl (base64Bytes, url, kwargs = {}, headers) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        url,
        {
          method: 'POST',
          mode: 'cors',
          body: base64Bytes ? JSON.stringify({data: base64Bytes, ...kwargs}) : JSON.stringify({...kwargs}),
          headers: headers ?  headers : {
            'Content-Type': 'application/json'
          },
          timeout: 30
        }
      ).then((response) => {
        return response.json()
      }
      ).then((ret) => {
        if (ret.code && ret.code != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        if (ret.status && ret.status != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject('timeout')
    }
  })
}

function getCommon (address, timeout = 30) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        address,
        {
          method: 'GET',
          mode: 'cors',
          timeout: timeout
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.code != 0)
          reject(ret)
        else
          resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject({code: -1, message: 'timeout', data: {}})
    }
  })
}

function postCommon (address, data, timeout = 30) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        address,
        {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify(data),
          headers:{
            'Content-Type': 'application/json'
          },
          timeout: timeout
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.code != 0) {
          reject(ret)
        }
        else
          resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject({code: -1, message: 'timeout', data: {}})
    }
  })
}

function deleteCommon (address, timeout = 30) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        address,
        {
          method: 'DELETE',
          mode: 'cors',
          timeout: timeout
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.code != 0) {
          reject(ret)
        }
        else
          resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject({code: -1, message: 'timeout', data: {}})
    }
  })
}

function putCommon (address, data, timeout = 30) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        address,
        {
          method: 'PUT',
          mode: 'cors',
          body: JSON.stringify(data),
          headers:{
            'Content-Type': 'application/json'
          },
          timeout: timeout
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.code != 0) {
          reject(ret)
        }
        else
          resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject({code: -1, message: 'timeout', data: {}})
    }
  })
}

async function getTemplate (suffix, timeout = 30) {
  let address = `${ipLoopBack}/api/template`
  if (suffix != undefined)
    address = [address, suffix].join('/')
  return await getCommon(address, timeout)
}

async function postTemplate (data, timeout = 30) {
  return await postCommon(`${ipLoopBack}/api/template`, data, timeout)
}

async function deleteTemplate (suffix, timeout = 30) {
  let address = `${ipLoopBack}/api/template`
  if (suffix != undefined)
    address = [address, suffix].join('/')
  return await deleteCommon(address, timeout)
}

async function updateTemplate (data, timeout = 30) {
  return await putCommon(`${ipLoopBack}/api/template`, data, timeout)
}

async function getSample (suffix, timeout = 30) {
  let address = `${ipLoopBack}/api/sample`
  if (suffix != undefined)
    address = [address, suffix].join('/')
  return await getCommon(address, timeout)
}

async function templateRecognize (file, layouts) {
  const base64Bytes = await toBase64(file);
  let form = {data: base64Bytes, layout: layouts}
  let response = await new Promise(function (resolve, reject) {
    try {
      fetch(
        `${ipLoopBack}/api/hwr`,
        {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify(form),
          headers:{
            'Content-Type': 'application/json'
          },
          timeout: 30
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.hwrErrorCode.code != 'ERR_SUCCESS') {
          const error = { message: 'failed to remove job. error code: ' + ret.hwrErrorCode.code }
          reject('인식 서버 오류, code: ' + ret.hwrErrorCode.code)
          return
        }
        resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject('timeout')
    }
  })

  if (response.candidates == undefined)
    throw 'invalid response'
  
  return response.candidates;
}

async function getDebugImage (data, timeout = 30) {
  return await postCommon(`${ipLoopBack}/api/debug`, data, timeout)
}

export default {
  ipLoopBack,
  recognizeImpl,
  getTemplate,
  postTemplate,
  deleteTemplate,
  updateTemplate,
  getSample,
  toBase64,
  templateRecognize,
  getDebugImage
}
